export interface PlanningFilterDayTimeTemplate {
  notBeforeDay: string;
  notBeforeTime: string;
  notAfterDay: string;
  notAfterTime: string;
}

export interface PlanningDraftLayer {
  id: string;
  stepOrder: number;
  name: string;
  jobFilter?: any;
  resourceFilter?: any;
  jobFilterDayTimeTemplate?: PlanningFilterDayTimeTemplate;
  resourceFilterDayTimeTemplate?: PlanningFilterDayTimeTemplate;
  settings: any;
  disabled?: boolean;
}

export const PLANNING_DRAFT_GLOBAL_TAB_ID = 'global';

export const PLANNING_FILTER_DAYS = ['Day1', 'Day2', 'Day3', 'Day4', 'Day5', 'LastDay'];

export const PLANNING_FILTER_DAY_LABELS = {
  Day1: 'Day 1',
  Day2: 'Day 2',
  Day3: 'Day 3',
  Day4: 'Day 4',
  Day5: 'Day 5',
  LastDay: 'Last Day'
};

export function buildDefaultDayTimeTemplate(): PlanningFilterDayTimeTemplate {
  return {
    notBeforeDay: 'Day1',
    notBeforeTime: '00:00',
    notAfterDay: 'LastDay',
    notAfterTime: '23:59'
  };
}
